module.exports = __webpack_public_path__ + "img/icon_play.393b30d7.png";